import React from 'react';
import useTransportationOrderService from '../../../app/services/hooks/useTransportationOrderService';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';
import { TransportationOrderStatusRequestDataForm } from '../../../app/models/TransportationOrder';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';

interface Props {
    transportationOrderId: number;
    statuses: TransportationOrderStatusRequestDataForm[];
    selectedStatus: TransportationOrderStatusRequestDataForm;
    callbackSuccess?: () => void;
}

const TransportationOrderChangeStatus = ({
    transportationOrderId,
    statuses,
    selectedStatus,
    callbackSuccess
}: Props) => {

    const [selected, setSelected] = React.useState(selectedStatus);

    const { 
        dispatchStatusTransportationOrder,
        finishedStatusTransportationOrder,
        annulledStatusTransportationOrder
    } = useTransportationOrderService();

    const eventChangeStatus = {
        onSuccess: (response: ServiceResponse) => {
            if (callbackSuccess) {
                callbackSuccess();
            }
    
            useReactConfirmAlert().successAlert({
                title: 'Éxito',
                message: `Se ha cambiado el estado del pedido #${transportationOrderId}`
            });
        },
        onError: (response: ServiceResponse) => {
            if (callbackSuccess) {
                callbackSuccess();
            }
    
            toast.error(response.message);
        }
    };

    const changeStatus = (value: string) => {
        if (value === selected.id) return;
    
        const _status = statuses.find(
            (status: TransportationOrderStatusRequestDataForm) => status.id === value
        );
    
        setSelected(_status!);
    
        const _text =
            'Está a punto de cambiar el estado del Pedido #' +
            transportationOrderId +
            ' a ' +
            (_status ? _status.name : '');
    
        useReactConfirmAlert().requestConfirmation({
            title: '¿Está seguro?',
            message: _text,
            buttons: {
                confirmButton: {
                    label: 'Sí, cambiar estado',
                    onClick: () => {
                        switch (value) {
                            case 'DESPACHO':
                                dispatchStatusTransportationOrder(transportationOrderId, eventChangeStatus);
                                break;
                            case 'FINALIZADO':
                                finishedStatusTransportationOrder(transportationOrderId, eventChangeStatus);
                                break;
                            case 'ANULAR':
                                annulledStatusTransportationOrder(transportationOrderId, eventChangeStatus);
                                break;
                            default:
                                useReactConfirmAlert().errorAlert({
                                    title: 'Error',
                                    message: 'Opción no encontrada.'
                                });
                                setSelected(selectedStatus);
                                break;
                        }
                    }
                },
                cancelButton: {
                    label: 'Cancelar',
                    onClick: () => {
                        setTimeout(() => {
                            useReactConfirmAlert().infoAlert({
                                title: 'Cancelado',
                                message: 'El estado del pedido no se ha cambiado.'
                            });
                            setSelected(selectedStatus);
                        }, 0);
                    }
                }
            },
            onClickOutsideFunction: () => {
                setSelected(selectedStatus); 
            }
        });
    };
    
    
    if (!selectedStatus) return null;

    return (
        <select
            className="form-control"
            value={selected.id}
            onChange={(e) => changeStatus(e.target.value)}
        >
            <option value={selectedStatus.id}>{selectedStatus.name}</option>
            {statuses.map((status) => {
                return (
                    <option key={status.id} value={status.id}>
                        {status.name}
                    </option>
                );
            })}
        </select>
    );
};

export default TransportationOrderChangeStatus;
